<h2 class="titleReSent" mat-dialog-title>{{'MAPP-VMS-RESENT.TITLE' | translate}}</h2>
<mat-dialog-content class="reSentVisitDialog">
    {{'MAPP-VMS-RESENT.CONTENT' | translate}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="reSentVisitButton" mat-button (click)="close()">{{'MAPP-VMS-RESENT.CANCEL' | translate}}</button>
    <button class="reSentVisitButton" mat-button (click)="reSentNotification()">{{'MAPP-VMS-RESENT.CONFIRM' | translate}}</button>
</mat-dialog-actions>
<empusa-mat-spinner-overlay *ngIf="loading" overlay="true"></empusa-mat-spinner-overlay>
